<div class="container">
  <h1 class="page-title">{{'maintenance.title'|traduccion}}</h1>
  <div appGridColumns [colsLg]="2" [colsMd]="1" [colsSm]="1">

    <mat-card *appShowForRoles="['ROLE_ADMIN']" class="card sync-card full-span">
      <mat-card-header>
        <mat-card-title>{{'maintenance.sync.cardTitle'|traduccion}}</mat-card-title>
        <mat-card-subtitle>{{'maintenance.sync.subtitle'|traduccion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="sync-content">
        <section class="sync-action-card">
          <div class="sync-action-copy">
            <div class="sync-action-header">
              <span class="sync-direction">{{'maintenance.sync.toapp'|traduccion}}</span>
              <h2>{{'maintenance.sync.toapp.title'|traduccion}}</h2>
            </div>
            <p>{{'maintenance.sync.toapp.description'|traduccion}}</p>
            <ul class="sync-scope-list">
              <li>{{'maintenance.sync.toapp.scope.config'|traduccion}}</li>
              <li>{{'maintenance.sync.toapp.scope.excluded'|traduccion}}</li>
            </ul>
          </div>

          <div class="sync-action-cta">
            <button mat-raised-button class="btn-pill" (click)="executeSync('toapp', {'config':null, 'category':null, 'product':null,'locker':null,'discount':null})">
              <mat-icon>cloud_download</mat-icon>
              <span>{{'maintenance.sync.toapp'|traduccion}}</span>
            </button>
          </div>
        </section>
      </mat-card-content>
    </mat-card>

    <mat-card *appShowForRoles="['ROLE_ADMIN']" class="card sync-card full-span danger-card">
      <mat-card-header>
        <mat-card-title>{{'maintenance.erase.cardTitle'|traduccion}}</mat-card-title>
        <mat-card-subtitle>{{'maintenance.erase.subtitle'|traduccion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="sync-content">
        <section class="sync-action-card danger-action-card">
          <div class="sync-action-copy">
            <div class="sync-action-header">
              <span class="sync-direction danger-direction">{{'maintenance.erase.kicker'|traduccion}}</span>
              <h2>{{'maintenance.erase.title'|traduccion}}</h2>
            </div>
            <p>{{'maintenance.erase.description'|traduccion}}</p>
            <ul class="sync-scope-list">
              <li>{{'maintenance.erase.scope.data'|traduccion}}</li>
              <li>{{'maintenance.erase.scope.warning'|traduccion}}</li>
            </ul>
          </div>

          <div class="sync-action-cta">
            <button mat-raised-button color="warn" class="btn-pill" [disabled]="erasingReservationData" (click)="eraseKioskReservationData()">
              <mat-icon>delete_forever</mat-icon>
              <span>{{'maintenance.erase.button'|traduccion}}</span>
            </button>
          </div>
        </section>
      </mat-card-content>
    </mat-card>

    <mat-card *appShowForRoles="['ROLE_MANAGER']" class="card">
      <mat-card-header>
        <mat-card-title>{{'maintenance.clean.title'|traduccion}}</mat-card-title>
        <mat-card-subtitle>{{'maintenance.clean.subtitle'|traduccion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="py-4">
        <button mat-raised-button class="btn-pill" (click)="boxexCleaning('BAGGAGE')">
          <mat-icon>luggage</mat-icon>
          <span>{{'maintenance.clean.baggage'|traduccion}}</span>
        </button>
        <button mat-raised-button class="btn-pill" (click)="boxexCleaning('KEY')">
          <mat-icon>vpn_key</mat-icon>
          <span>{{'maintenance.clean.key'|traduccion}}</span>
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card *appShowForRoles="['ROLE_MANAGER']" class="card">
      <mat-card-header>
        <mat-card-title>Codigo de limpieza</mat-card-title>
        <mat-card-subtitle>Configura el codigo interno usado en tareas de limpieza.</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="py-4 cleaning-code-content">
        <form [formGroup]="cleaningCodeForm" class="cleaning-code-form">
          <mat-form-field appearance="outline">
            <mat-label>Codigo de limpieza</mat-label>
            <input matInput formControlName="cleaningCode" placeholder="Ej. CLEAN-01">
            <mat-error *ngIf="cleaningCodeForm.get('cleaningCode')?.hasError('required')">Este campo es obligatorio.</mat-error>
            <mat-error *ngIf="cleaningCodeForm.get('cleaningCode')?.hasError('maxlength')">El texto supera la longitud maxima permitida.</mat-error>
          </mat-form-field>
        </form>
        <button mat-raised-button class="btn-pill" color="primary" [disabled]="savingCleaningCode" (click)="saveCleaningCode()">
          <mat-icon>save</mat-icon>
          <span>Guardar codigo</span>
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card *appShowForRoles="['ROLE_MANAGER']" class="card">
      <mat-card-header>
        <mat-card-title>{{'maintenance.reload.title'|traduccion}}</mat-card-title>
        <mat-card-subtitle>{{'maintenance.reload.subtitle'|traduccion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="py-4">
        <button mat-stroked-button class="btn-pill" (click)="sendAction('reloadApp')">
          <mat-icon>refresh</mat-icon>
          <span>{{'maintenance.reload.app'|traduccion}}</span>
        </button>
        <button mat-stroked-button class="btn-pill" (click)="sendAction('payment_dataphone.reload')">
          <mat-icon>point_of_sale</mat-icon>
          <span>{{'maintenance.reload.dataphone'|traduccion}}</span>
        </button>
        <button mat-stroked-button class="btn-pill">
          <mat-icon>point_of_sale</mat-icon>
          <span>{{'maintenance.reload.kiosk'|traduccion}}</span>
        </button>
      </mat-card-content>
    </mat-card>

    <mat-card *appShowForRoles="['ROLE_MANAGER']" class="card">
      <mat-card-header>
        <mat-card-title>{{'maintenance.modeAdmin.title'|traduccion}}</mat-card-title>
        <mat-card-subtitle>{{'maintenance.modeAdmin.subtitle'|traduccion}}</mat-card-subtitle>
      </mat-card-header>
      <mat-divider></mat-divider>
      <mat-card-content class="py-4">
        <button mat-raised-button class="btn-pill" (click)="sendAction('utils_setadminmode', {active: 1})">
          <mat-icon>admin_panel_settings</mat-icon>
          <span>{{'maintenance.modeAdmin.enable'|traduccion}}</span>
        </button>
        <button mat-raised-button class="btn-pill" (click)="sendAction('utils_setadminmode', {active: 0})">
          <mat-icon>block</mat-icon>
          <span>{{'maintenance.modeAdmin.disable'|traduccion}}</span>
        </button>
      </mat-card-content>
    </mat-card>

  </div>
</div>
